module.exports = __webpack_public_path__ + "static/urtisanlogo-10991a8e02ec7ad2e0e0fbff16186bf5.png";